import { createSafeContext } from '@mantine/core';
import { SpringValue } from '@react-spring/web';

const [SwipeableProvider, useSwipeableContext] = createSafeContext<{
  x: SpringValue<number>;
  leftActionRef: React.MutableRefObject<(() => void) | undefined>;
  rightActionRef: React.MutableRefObject<(() => void) | undefined>;
}>('SwipeableActionProvider component was not found in tree');

export { SwipeableProvider, useSwipeableContext };
